module.exports = __webpack_public_path__ + "static/media/audio.ba1835f9.svg";